import Eco from 'yxt-biz-pc/packages/eco';
export default Eco;
